import {Component} from '@angular/core';
import {RecipeEditorV2Component} from "../../components/recipe-editor-v2/recipe-editor-v2.component";

@Component({
  selector: 'app-recipe-editor-debugger',
  imports: [
    RecipeEditorV2Component
  ],
  templateUrl: './recipe-editor-debugger.component.html',
  styleUrl: './recipe-editor-debugger.component.scss'
})
export class RecipeEditorDebuggerComponent {
  serializedFromV2: string = '';

  onSerializedV2Change(text: string): void {
    this.serializedFromV2 = text;
  }

  ingredientNames = [
    // Grundzutaten
    "Mehl",
    "Weizenmehl",
    "Dinkelmehl",
    "Roggenmehl",
    "Vollkornmehl",
    "Zucker",
    "Puderzucker",
    "Brauner Zucker",
    "Vanillezucker",
    "Salz",
    "Jodsalz",
    "Hefe",
    "Trockenhefe",
    "Frischhefe",
    "Butter",
    "Margarine",
    "Milch",
    "Wasser",
    "Mineralwasser",
    "Öl",
    "Olivenöl",
    "Sonnenblumenöl",
    "Rapsöl",
    "Kokosöl",

    // Eier & Milchprodukte
    "Ei",
    "Eier",
    "Eigelb",
    "Eiweiß",
    "Sahne",
    "Schlagsahne",
    "Crème fraîche",
    "Saure Sahne",
    "Joghurt",
    "Naturjoghurt",
    "Griechischer Joghurt",
    "Quark",
    "Frischkäse",
    "Mascarpone",
    "Ricotta",
    "Käse",
    "Hartkäse",
    "Weichkäse",
    "Gouda",
    "Emmentaler",
    "Bergkäse",
    "Parmesan",
    "Mozzarella",
    "Cheddar",
    "Feta",

    // Gemüse
    "Zwiebel",
    "Zwiebeln",
    "Knoblauch",
    "Knoblauchzehe",
    "Schalotte",
    "Lauch",
    "Porree",
    "Karotte",
    "Karotten",
    "Möhre",
    "Möhren",
    "Sellerie",
    "Knollensellerie",
    "Staudensellerie",
    "Paprika",
    "Rote Paprika",
    "Grüne Paprika",
    "Gelbe Paprika",
    "Tomate",
    "Tomaten",
    "Cherrytomaten",
    "Gurke",
    "Zucchini",
    "Aubergine",
    "Brokkoli",
    "Blumenkohl",
    "Spinat",
    "Mangold",
    "Grünkohl",
    "Weißkohl",
    "Rotkohl",
    "Rosenkohl",
    "Chinakohl",
    "Kartoffel",
    "Kartoffeln",
    "Süßkartoffel",
    "Radieschen",
    "Rettich",
    "Kürbis",
    "Hokkaido",
    "Butternut",
    "Erbsen",
    "Grüne Erbsen",
    "Mais",
    "Zuckermais",
    "Bohnen",
    "Grüne Bohnen",
    "Kidneybohnen",
    "Weiße Bohnen",
    "Kichererbsen",
    "Linsen",
    "Rote Linsen",
    "Gelbe Linsen",

    // Obst
    "Apfel",
    "Äpfel",
    "Birne",
    "Banane",
    "Zitrone",
    "Limette",
    "Orange",
    "Mandarine",
    "Erdbeeren",
    "Himbeeren",
    "Blaubeeren",
    "Heidelbeeren",
    "Johannisbeeren",
    "Kirschen",
    "Pfirsich",
    "Aprikose",
    "Pflaume",
    "Zwetschge",
    "Ananas",
    "Mango",
    "Kiwi",
    "Trauben",
    "Rosinen",
    "Datteln",
    "Feigen",

    // Fleisch
    "Rindfleisch",
    "Rinderhack",
    "Hackfleisch",
    "Schweinefleisch",
    "Schweinehack",
    "Hähnchen",
    "Hähnchenbrust",
    "Hähnchenschenkel",
    "Putenfleisch",
    "Lammfleisch",
    "Kalbfleisch",
    "Bacon",
    "Speck",
    "Schinken",
    "Wiener Würstchen",
    "Bratwurst",
    "Salami",

    // Fisch & Meeresfrüchte
    "Fisch",
    "Lachs",
    "Räucherlachs",
    "Thunfisch",
    "Forelle",
    "Kabeljau",
    "Seelachs",
    "Scholle",
    "Garnelen",
    "Shrimps",
    "Krabben",
    "Muscheln",

    // Getreide & Beilagen
    "Reis",
    "Langkornreis",
    "Basmatireis",
    "Jasminreis",
    "Risottoreis",
    "Nudeln",
    "Spaghetti",
    "Penne",
    "Fusilli",
    "Lasagneplatten",
    "Gnocchi",
    "Couscous",
    "Bulgur",
    "Quinoa",
    "Haferflocken",
    "Dinkel",
    "Gerste",
    "Grieß",
    "Polenta",
    "Semmelbrösel",
    "Paniermehl",
    "Toastbrot",
    "Brot",
    "Brötchen",

    // Nüsse & Samen
    "Mandeln",
    "Haselnüsse",
    "Walnüsse",
    "Cashewkerne",
    "Erdnüsse",
    "Pistazien",
    "Sesam",
    "Sonnenblumenkerne",
    "Kürbiskerne",
    "Leinsamen",
    "Chiasamen",
    "Mohn",

    // Gewürze
    "Pfeffer",
    "Schwarzer Pfeffer",
    "Weißer Pfeffer",
    "Paprikapulver",
    "Edelsüßes Paprikapulver",
    "Rosenpaprika",
    "Chilipulver",
    "Cayennepfeffer",
    "Zimt",
    "Muskat",
    "Muskatnuss",
    "Nelken",
    "Ingwer",
    "Kurkuma",
    "Kreuzkümmel",
    "Koriander",
    "Kardamom",
    "Anis",
    "Fenchel",
    "Senf",
    "Senfkörner",

    // Kräuter
    "Petersilie",
    "Schnittlauch",
    "Basilikum",
    "Thymian",
    "Rosmarin",
    "Oregano",
    "Majoran",
    "Dill",
    "Kerbel",
    "Estragon",
    "Lorbeerblatt",
    "Lorbeerblätter",

    // Backzutaten
    "Backpulver",
    "Natron",
    "Hirschhornsalz",
    "Vanille",
    "Vanilleschote",
    "Kakaopulver",
    "Schokolade",
    "Zartbitterschokolade",
    "Vollmilchschokolade",
    "Kuvertüre",
    "Kokosraspeln",
    "Marzipan",
    "Nougat",
    "Gelatine",
    "Agavendicksaft",
    "Ahornsirup",
    "Honig",

    // Saucen & Flüssigkeiten
    "Essig",
    "Apfelessig",
    "Balsamico",
    "Sojasauce",
    "Worcestersauce",
    "Tomatenmark",
    "Passierte Tomaten",
    "Gemüsebrühe",
    "Rinderbrühe",
    "Hühnerbrühe",
    "Fond",
    "Wein",
    "Weißwein",
    "Rotwein",
    "Bier",

    // Sonstiges
    "Hefeextrakt",
    "Kapern",
    "Oliven",
    "Gewürzgurken",
    "Sauerkraut",
    "Rotkohl aus dem Glas",
    "Apfelmus",
    "Preiselbeeren",
    "Mayonnaise",
    "Ketchup",
    "Senf",
    "Remoulade"
  ];

}
